const modes = {
  // eslint-disable-next-line no-undef
  test: TEST_MODE,
  // eslint-disable-next-line no-undef
  www: WWW_MODE,
  // eslint-disable-next-line no-undef
  local: LOCAL_MODE
}

// eslint-disable-next-line no-undef
const mode = MODE

// eslint-disable-next-line no-undef
const types = TYPES
// eslint-disable-next-line no-unused-vars, no-undef
const links = LINKS
// eslint-disable-next-line no-unused-vars, no-undef
const adSlots = ADSLOT

const config = {
  // host: process.env.VUE_APP_HOST,
  // api_host: process.env.VUE_APP_API_HOST,
  // rc_host: process.env.VUE_APP_RC_HOST,

  mode: mode,
  host: modes[mode].host,
  api_host: modes[mode].api,
  rc_host: modes[mode].rc,
  iconTypes: types,
  iconLinks: links,
  adSlots: adSlots,

  app_id: modes[mode].appId,
  wechart_app_id: modes[mode].wechartAppId,

  version: process.env.VUE_APP_VERSION,
  check_auth: process.env.VUE_APP_CHECK_AUTH,
  project_token: process.env.VUE_APP_PROJECT_TOKEN,
  title: process.env.VUE_APP_PROJECT_TITLE,
  company: process.env.VUE_APP_COMPANY
}

export default config
